<div *ngIf="visible" class="popup-container" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2>{{ title }}</h2>
    </div>
    <div class="popup-body">
      <p>{{ message }}</p>
    </div>
    <div class="popup-footer">
      <button class="close-button" (click)="close()">Chiudi</button>
    </div>
  </div>
</div>